import { render, staticRenderFns } from "./BulkPromotionUploadStatus.vue?vue&type=template&id=5ee6290f"
import script from "./BulkPromotionUploadStatus.vue?vue&type=script&lang=js"
export * from "./BulkPromotionUploadStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports